// @ts-nocheck
import React, {useState, useEffect} from 'react'
import styles from './../css/ChangeTargetDrop.module.css'
import Edit from './EditTarget'
import apiFetch from '../../../../api/apiFetch'
import Icon from '../../../../components/Icon/Icon';

function ChangeTargetDrop(props) {

    const [edit, setEdit] = useState(false)
    const [targetType, setTargetType] = useState(props.data.TARGET_TYPE || "")
    const [reason, setReason] = useState(props.data.REASON || "")
    const [notes, setNotes] = useState(props.data.NOTES || "")
    const [tempTarget, setTempTarget] = useState()
    const exercise = props.exercise;

    useEffect(() => {
        setTargetType(targetType !== props.data.CURRENT_TARGET_VALUE ? targetType : "")
    }, [])

    const submit = (target, reasons) => {
        let temp = {
            ...reasons,
            ID: props.data.TARGETING_EXERCISE_ID,
            terr: props.terr,
            type: props.exercise.CUSTOMER_TYPE,
            mdmID: props.data.PROF_ID,
            target: target !== "" ? target : props.data.CURRENT_TARGET_VALUE,
            oldTarget: targetType !== "" ? targetType : props.data.CURRENT_TARGET_VALUE,
            user: props.user,
            role: props.user.role,
            username: props.user.userName
        }
        apiFetch('/api/v2/targeting/set-target-type', temp).then((data) => {
            if (reasons) {
                setReason(reasons.reason)
                setNotes(reasons.notes)
            }
            setTargetType(target)
            props.data.TARGET_TYPE = target
            setEdit(false)
            props.getTotals()
        })
    }

    const close = () => {
        setTempTarget(null)
        setEdit(false)
    }

    let popup = ""
    let placeholder = ""
    let editIcon = ""
    if (edit) {
        popup = <Edit {...props} targetType={tempTarget || targetType} reason={reason} notes={notes} success={true} successMessage={"Test"} submit={submit} close={close}/>
    }
    if (targetType !== "" && targetType !== props.data.CURRENT_TARGET_VALUE) {
        placeholder = (
            <>
                <div className={styles.placeholder}></div>
                <div className={styles.placeholder}></div>
            </>
        )
        editIcon = (
            <>
                <div className={styles.placeholder}><div className={styles.line}></div></div>
                <div className={styles.edit}>
                    <Icon name="edit" onClick={() => {
                        setEdit(true)
                    }} />
                </div>

            </>
        )
    }

    let options = []
    options.push(<option value={""}></option>)
    options.push(<option value={"A"}>A</option>)
    options.push(<option value={"B"}>B</option>)
    options.push(<option value={"C"}>C</option>)
    if (props.data.CURRENT_TARGET_VALUE !== "E") options.push(<option value={"NT"}>NT</option>)

    return (
        <div>
            {popup}
            <div className={styles.changeTargetDrop}>
                {placeholder}
                <select className={[styles.dropdown, styles[targetType]].join(" ")} value={targetType} onChange={(event) => {
                        const newVal = event.target.value

                        if (newVal.includes("NT") && props.data.CURRENT_TARGET_VALUE === "E") {
                            props.updateError()
                            return
                        }

                        // Selecting blank or the original value removes any active override — no reason code needed
                        if (newVal === "" || newVal === props.data.CURRENT_TARGET_VALUE) {
                            if (targetType !== "") {
                                setTargetType("")
                                submit("", {})
                            }
                            return
                        }

                        const isUpgrade = newVal < props.data.CURRENT_TARGET_VALUE
                        const hasReasonCodes = Array.isArray(props.options)
                            ? props.options.length > 0
                            : (isUpgrade ? (props.options?.upgrade?.length > 0) : (props.options?.downgrade?.length > 0))

                        if (hasReasonCodes) {
                            setEdit(true)
                            setTempTarget(newVal)
                        } else {
                            setTargetType(newVal)
                            submit(newVal, {})
                        }
                    }} disabled={props.lock}>

                    <>{options}</>
               
                </select>
                {editIcon}
            </div>
        </div>
    )
}

export default ChangeTargetDrop
